module.exports = __webpack_public_path__ + "media/flags/cw-420d655f.svg";